import {
  isComplexElement,
  isSlotElement,
  type LayoutNode,
  type NodeV2,
  type NodeV2Style,
} from '@vedalib/editor'

import type { Block } from 'services/Store/Project/types'

import { getParentNode } from '../EditorContext/selectors/block'

export const isRoot = (block: Block, node?: LayoutNode | null) => block.schema.rootId === node?.id
export const isComplexElementItem = (block?: Block, node?: NodeV2) => {
  const parent = getParentNode(node?.id, block)
  const element = parent?.elementId ? block?.elements[parent.elementId] : null
  if (!element) {
    return false
  }
  return isComplexElement(element)
}
export const isSlotElementItem = (block?: Block | null, node?: NodeV2 | null) => {
  const parent = getParentNode(node?.id, block)
  const element = parent?.elementId ? block?.elements[parent.elementId] : null
  if (!element) {
    return false
  }
  return isSlotElement(element)
}
export const isElement = (node?: NodeV2) => Boolean(node?.elementId)
export const isGrid = (style?: NodeV2Style | null): style is NodeV2Style =>
  style?.display === 'grid'
export const isFlex = (style?: NodeV2Style | null): style is NodeV2Style =>
  style?.display === 'flex'
export const isAbsolute = (style?: NodeV2Style | null): style is NodeV2Style =>
  style?.display === 'absolute'
